import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { CLAIMS_METRICS_EXCLUSION_DATA_API_URL, CLAIMS_PROCESSED_DATA_API_URL, DOP_CLAIMS_PROCESSED_DATA_API_URL, CLAIMS_BULK_PROCESS_API_URL, DOP_CLAIMS_BULK_PROCESS_API_URL, CLAIMS_METRICS_EXCLUSION_BULK_PROCESS_API_URL, CLAIMS_PROCESSED_MONTHLY_API_URL, CLAIMS_PROCESSED_MONTHLY_BULK_API_URL } from './apiUrlConstants';

const _httpService = new HttpService();
const _httpServiceBulk = new HttpService();

const apiDomainInternal = config('API_DOMAIN_INTERNAL') ?? '';
const apiDomainExternal = config('API_DOMAIN_EXTERNAL') ?? '';

if (checkIsInternal()) {
  _httpService.setBaseURL(apiDomainInternal);
  _httpServiceBulk.setBaseURL(config('BULK_PROCESSING_API') || '');
} else {
  _httpService.setBaseURL(apiDomainExternal);
  _httpServiceBulk.setBaseURL(config('BULK_PROCESSING_API') || '');
}

export const getClaimsProcessedDataRequest = async (payload: any, highVolumeTinFlag?: boolean) => {
  // ============================================================
  // DUAL-FLOW LOGIC based on highVolumeTinFlag
  // - If highVolumeTinFlag is false/undefined: Normal flow → Standard API → Immediate response
  // - If highVolumeTinFlag is true: Polling flow → Bulk API → Job submission
  // ============================================================
  const isPollingFlow = highVolumeTinFlag === true;
  
  if (isPollingFlow) {
    // ============================================================
    // POLLING FLOW - Use Bulk Processing API
    // API: /claims-bulk-process-jobs/dos-claim-metrics?request-type=PAYMENT_METRICS
    // Returns: { Data: { JobId, Status, Message } }
    // ============================================================
    
    const url = `${CLAIMS_BULK_PROCESS_API_URL}?request-type=PAYMENT_METRICS`;
    try {
      const responseData: any = await _httpServiceBulk.push(url, payload);
      return responseData;
    } catch (error: any) {
      console.error('Claims Processed Bulk Service Error:', error);
      throw error;
    }
  } else {
    // ============================================================
    // NORMAL FLOW - Use Standard API (existing behavior)
    // API: /claim-metrics/?request-type=PAYMENT_METRICS
    // Returns: Direct data response
    // ============================================================
    
    const url = `${CLAIMS_PROCESSED_DATA_API_URL}?request-type=PAYMENT_METRICS`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData?.Data || responseData;
    } catch (error: any) {
      console.error('Claims Processed Service Error:', {
        error: error?.message || error,
        status: error?.status || error?.response?.status,
        url,
        payload
      });
      throw error;
    }
  }
};

export const getClaimsMetricsExclusionDataRequest = async (payload: any, highVolumeTinFlag?: boolean) => {
  // ============================================================
  // DUAL-FLOW LOGIC based on highVolumeTinFlag
  // - If highVolumeTinFlag is false/undefined: Normal flow → Standard API → Immediate response
  // - If highVolumeTinFlag is true: Polling flow → Bulk API → Job submission
  // ============================================================
  const isPollingFlow = highVolumeTinFlag === true;
  
  if (isPollingFlow) {
    // ============================================================
    // POLLING FLOW - Use Bulk Processing API
    // API: /claims-bulk-process-jobs/claim-metrics-by-exclusion
    // Returns: { Data: { JobId, Status, Message } }
    // ============================================================
    
    const url = `${CLAIMS_METRICS_EXCLUSION_BULK_PROCESS_API_URL}`;
    try {
      const responseData: any = await _httpServiceBulk.push(url, payload);
      return responseData;
    } catch (error: any) {
      console.error('Claims Metrics Exclusion Bulk Service Error:', error);
      throw error;
    }
  } else {
    // ============================================================
    // NORMAL FLOW - Use Standard API (existing behavior)
    // API: /claim-metrics-by-exclusion
    // Returns: Direct data response
    // ============================================================
const url = `${CLAIMS_METRICS_EXCLUSION_DATA_API_URL}`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData?.Data || responseData;
    } catch (error: any) {
      console.error('Claims Metrics Exclusion Service Error:', {
        error: error?.message || error,
        status: error?.status || error?.response?.status,
        url,
        payload
      });
      throw error;
    }
  }
};

export const getDopClaimsMetricsClaimsDataRequest = async (payload: any, highVolumeTinFlag?: boolean) => {
  const isPollingFlow = highVolumeTinFlag === true;
  if (isPollingFlow) {
    // Use Bulk Processing API for DOP CLAIMS
    const url = `${DOP_CLAIMS_BULK_PROCESS_API_URL}?request-type=CLAIMS`;
    try {
      const responseData: any = await _httpServiceBulk.push(url, payload);
      return responseData;
    } catch (error: any) {
      console.error('DOP Claims Metrics Claims Bulk Service Error:', error);
      throw error;
    }
  } else {
    const url = `${DOP_CLAIMS_PROCESSED_DATA_API_URL}?request-type=CLAIMS`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData?.Data || responseData;
    } catch (error: any) {
      console.error('DOP Claims Metrics Claims Service Error:', error);
      throw error;
    }
  }
}

export const getDopClaimsMetricsTatDataRequest = async (payload: any, highVolumeTinFlag?: boolean) => {
  const isPollingFlow = highVolumeTinFlag === true;
  if (isPollingFlow) {
    // Use Bulk Processing API for DOP TAT
    const url = `${DOP_CLAIMS_BULK_PROCESS_API_URL}?request-type=TAT`;
    try {
      const responseData: any = await _httpServiceBulk.push(url, payload);
      return responseData;
    } catch (error: any) {
      console.error('DOP Claims Metrics TAT Bulk Service Error:', error);
      throw error;
    }
  } else {
    const url = `${DOP_CLAIMS_PROCESSED_DATA_API_URL}?request-type=TAT`;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData?.Data || responseData;
    } catch (error: any) {
      console.error('DOP Claims Metrics TAT Service Error:', {
        error: error?.message || error,
        status: error?.status || error?.response?.status,
        url,
      });
      throw error;
    }
  }
}
export const getClaimsProcessedMonthlyDataRequest = async (payload: any, highVolumeTinFlag?: boolean) => {
  const isPollingFlow = highVolumeTinFlag === true;

  if (isPollingFlow) {
    // ============================================================
    // POLLING FLOW - Use Bulk Processing API
    // API: /claims-bulk-process-jobs/claims-processed-monthly
    // Returns: { Data: { JobId, Status, Message } }
    // ============================================================
    console.info('[ClaimsProcessed Monthly Service] Using BULK PROCESSING API for polling flow');
    const url = CLAIMS_PROCESSED_MONTHLY_BULK_API_URL;
    try {
      const responseData: any = await _httpServiceBulk.push(url, payload);
      console.info('[ClaimsProcessed Monthly Service] Bulk API job submission response:', responseData);
      return responseData;
    } catch (error: any) {
      console.error('Claims Processed Monthly Bulk Service Error:', {
        error: error?.message || error,
        status: error?.status || error?.response?.status,
        url,
        payload,
      });
      throw error;
    }
  } else {
    // ============================================================
    // NORMAL FLOW - Use Standard API (existing behavior)
    // ============================================================
    const url = CLAIMS_PROCESSED_MONTHLY_API_URL;
    try {
      const responseData: any = await _httpService.push(url, payload);
      return responseData?.Data || responseData;
    } catch (error: any) {
      throw error;
    }
  }
};
